import { useQuery } from 'react-apollo';

import { getPurchasedCustomPrint } from '../queries/getPurchasedCustomPrint';
import useAccountCardConfigure from '../../../../cards/views/AccountCardConfigurator/useAccountCardConfigure';

const useAdminPurchasedCustomPrintConfigurator = ({
  purchasedCustomPrintId,
}) => {
  const { loading, data } = useQuery(getPurchasedCustomPrint, {
    variables: {
      purchased_custom_print_id: purchasedCustomPrintId,
    },
    skip: !purchasedCustomPrintId,
  });

  const albumCustomPrint = data?.purchasedCustomPrint;
  const { account_card: customPrintAccountCard } =
    albumCustomPrint?.account_card ?? {};

  const {
    accountCard,
    loadingAccountCard,
    onElementConfigurationChange,
    cardElementLoading,
  } = useAccountCardConfigure({
    accountCardId: customPrintAccountCard?.id,
  });

  return {
    loading,
    albumCustomPrint,
    accountCardConfiguration: {
      loadingAccountCard,
      accountCard,
      onElementConfigurationChange,
      cardElementLoading,
    },
  };
};

export default useAdminPurchasedCustomPrintConfigurator;
